import { render, staticRenderFns } from "./inactive.vue?vue&type=template&id=431dc8e5&"
import script from "./inactive.vue?vue&type=script&lang=js&"
export * from "./inactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports